import { API_URL, CMS_URL, THEME_COLOR } from "../../constant";
import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BrowserRouter as Router, Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
// import "./Qiana.css";

import Logo from "../../images/logo.png";
import Banner1 from "../../images/replicate/top-5-september/Top 5 Promo Sept E-Commerce - 1.jpg";
import Banner2 from "../../images/replicate/top-5-september/Top 5 Promo Sept E-Commerce - 2.jpg";
import Banner3 from "../../images/replicate/top-5-september/Top 5 Promo Sept E-Commerce - 3.jpg";
import Banner4 from "../../images/replicate/top-5-september/Top 5 Promo Sept E-Commerce - 4.jpg";
import Banner5 from "../../images/replicate/top-5-september/Top 5 Promo Sept E-Commerce - 5.jpg";
import Banner6 from "../../images/Website Banner 1400 x 600 px Brosur Sept 2022.jpg";

import Keunggulan1 from "../../images/replicate/icon-keunggulan/ICON KEUNGGULAN-FOOD SAFE.png";
import Keunggulan2 from "../../images/replicate/icon-keunggulan/ICON KEUNGGULAN-BPA FREE.png";
import Keunggulan3 from "../../images/replicate/icon-keunggulan/ICON KEUNGGULAN-NON TOXIC.png";
import Keunggulan4 from "../../images/replicate/icon-keunggulan/ICON KEUNGGULAN-ISO STANDARD.png";
import Keunggulan5 from "../../images/replicate/icon-keunggulan/ICON KEUNGGULAN-MOOR LIFETIME GUARANTEE.png";

import Kategori1 from "../../images/replicate/kategori-produk/Kategori Produk-SERVING COLLECTION-2.jpg";
import Kategori2 from "../../images/replicate/kategori-produk/Kategori Produk-SMART STORAGE-2.jpg";
import Kategori3 from "../../images/replicate/kategori-produk/Kategori Produk-KITCHEN QUEEN-2.jpg";
import Kategori4 from "../../images/replicate/kategori-produk/Kategori Produk-READY TO GO-2.jpg";
import Kategori5 from "../../images/replicate/kategori-produk/Kategori Produk-DRINK WITH STYLE-2.jpg";
import Kategori6 from "../../images/replicate/kategori-produk/Kategori Produk-BIOCHEF-2.jpg";

import KOL1 from "../../images/replicate/kol/KOL-OLLA RAMLAN.jpg";
import KOL2 from "../../images/replicate/kol/KOL-SANDRA DEWI.jpg";
import KOL3 from "../../images/replicate/kol/KOL-CHELSEA OLIVIA.jpg";
import KOL4 from "../../images/replicate/kol/KOL-SHARENA DELON.jpg";

import ButtonMau from "../../images/replicate/buttons/BUTTON-MAU.png";
import ButtonClickHere from "../../images/replicate/buttons/BUTTON INFORMASI KLIK DISINI.png";
import ButtonShopNow from "../../images/replicate/buttons/BUTTON SHOP NOW.png";
import ButtonFB from "../../images/replicate/buttons/BUTTON SOSMED-FB.png";
import ButtonIG from "../../images/replicate/buttons/BUTTON SOSMED-IG.png";
import ButtonTikTok from "../../images/replicate/buttons/BUTTON SOSMED-TIKTOK.png";
import ButtonYt from "../../images/replicate/buttons/BUTTON SOSMED-YOUTUBE.png";
import ButtonTestiPrev from "../../images/replicate/buttons/BUTTON TESTIMONIAL 1.png";
import ButtonTestiNext from "../../images/replicate/buttons/BUTTON TESTIMONIAL 2.png";
import ButtonJoinNow from "../../images/replicate/buttons/BUTTON-JOIN NOW.png";
import ButtonBeliQiana from "../../images/replicate/buttons/BUTTON BELI QIANA.png";
import ButtonMauQiana from "../../images/replicate/buttons/BUTTON MAU QIANA.png";

import FotoProduk from "../../images/replicate/qiana/foto produk/QIANA BLUE.jpg";
import FiturProduk1 from "../../images/replicate/qiana/fitur qiana/FITUR QIANA 1.png";
import FiturProduk2 from "../../images/replicate/qiana/fitur qiana/FITUR QIANA 2.png";
import FiturProduk3 from "../../images/replicate/qiana/fitur qiana/FITUR QIANA 3.png";
import FiturProduk4 from "../../images/replicate/qiana/fitur qiana/FITUR QIANA 4.png";

import RegisterStep1 from "../../images/replicate/icon-daftar-member/ICON-CHAT.png";
import RegisterStep2 from "../../images/replicate/icon-daftar-member/ICON-DATA DIRI.png";
import RegisterStep3 from "../../images/replicate/icon-daftar-member/ICON-BELANJA.png";
import RegisterStep4 from "../../images/replicate/icon-daftar-member/ICON-TERDAFTAR.png";

import Testimoni1 from "../../images/replicate/testimoni/TESTIMONI-CUT AGUSTIAWATI.jpg";
import Testimoni2 from "../../images/replicate/testimoni/TESTIMONI-ERNI MARLINA DEWI.jpg";
import Testimoni3 from "../../images/replicate/testimoni/TESTIMONI-FENY SASMITA.jpg";
import Testimoni4 from "../../images/replicate/testimoni/TESTIMONI-MARIANA.jpg";
import Testimoni5 from "../../images/replicate/testimoni/TESTIMONI-RIAMA.jpg";
import Testimoni6 from "../../images/replicate/testimoni/TESTIMONI-YESI FITRI.jpg";

const Qiana = (props) => {
  const [memberID, setMemberID] = useState("");
  const [banners, setBanners] = useState([]);
  const [features, setFeatures] = useState([]);
  const [button, setButton] = useState("");
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const slider = React.useRef(null);
  const NextTestimonialButton = () => {
    return <img src={ButtonTestiNext} id="NextTestimonial" />;
  };
  const PrevTestimonialButton = () => {
    return <img src={ButtonTestiPrev} id="PrevTestimonial" />;
  };
  const settingsBanner = {
    dots: true,
    autoplay: true,
    infinite: true,
    arrows: false,
    className: "banner-slider",
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const settingsKol = {
    dots: false,
    autoplay: false,
    infinite: true,
    arrows: true,
    className: "banner-slider",
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };
  const settingsTestimoni = {
    dots: false,
    autoplay: false,
    infinite: true,
    arrows: false,
    className: "banner-slider",
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  function checkMemberID() {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    return fetch(
      `${API_URL}api/check/profile/${props.match.params.id}`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => {});
  }

  function getBanner() {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    return fetch(`${API_URL}api/banner`, requestOptions)
      .then((response) => response.json())
      .catch((error) => {});
  }

  function getLandingPage() {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    return fetch(
      `${API_URL}api/landingpage/${props.match.params.name}`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => {});
  }

  function setLog(url, type) {
    var urlencoded = new URLSearchParams();
    urlencoded.append("address", url);
    urlencoded.append("type", type);

    var requestOptions = {
      method: "POST",
      body: urlencoded,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/log`, requestOptions)
      .then((response) => response.text())
      .catch((error) => console.log("error", error));
  }

  function clickLink(url, type) {
    setLog(url, type);
    window.open(url, "_blank").focus();
  }

  useEffect(async () => {
    await setLog(`${props.location.pathname}`, "home");

    let resbanner = await getBanner();
    if (resbanner && resbanner.status == 200) {
      setBanners(resbanner.data);
    }

    let reslandingpage = await getLandingPage();
    if (reslandingpage && reslandingpage.status == 200) {
      let tbanner = [];
      let tfeature = [];
      let ttitle = "";
      let tbody = "";
      let tbutton = "";
      if (reslandingpage.data.length > 0) {
        for (let index = 0; index < reslandingpage.data.length; index++) {
          const element = reslandingpage.data[index];
          if (element.Type == "HeaderBanner") {
            tbanner.push(element);
          } else if (element.Type == "Title") {
            ttitle = element;
          } else if (element.Type == "Body") {
            tbody = element;
          } else if (element.Type == "Feature") {
            tfeature.push(element);
          } else if (element.Type == "Button") {
            tbutton = element;
          }
        }
        setBanners(tbanner);
        setTitle(ttitle);
        setBody(tbody);
        setFeatures(tfeature);
        setButton(tbutton);
      }
    }

    let response = await checkMemberID();
    if (response && response.status == 200) {
      setMemberID(props.match.params.id);
      let div = document.getElementById("container");
      div.classList.remove("container");
    } else {
      window.location = "/";
    }
  }, []);

  return (
    <React.StrictMode>
      <div className="center lp-padding10">
        <img src={Logo} className="lp-logo" />
      </div>
      <div className="">
        <Slider {...settingsBanner}>
          {
            // banners.map((value, index) => {
            //     let arrs = (value.Link).split("/");
            //     let id = arrs[arrs.length-1]
            //     return (<div>
            //         {
            //             (value.Type == 1) ?(
            //                 <Link to={`/shoppromo/${memberID}?p=${id}`} target="_blank">
            //                     <img src={`${CMS_URL}/images/upload/banner/${value.Image}`} class="banner-image" />
            //                 </Link>
            //             ):(
            //                 <a href={`${value.Link}`} target="_blank">
            //                     <img src={`${CMS_URL}/images/upload/banner/${value.Image}`} class="banner-image" />
            //                 </a>
            //             )
            //         }
            //     </div>)
            // })
            banners.map((value, index) => {
              return (
                <div>
                  {
                    <Link
                      to={`/shopitem/${memberID}?i=${value.ItemUnitID}`}
                      target="_blank"
                    >
                      <img
                        src={`${CMS_URL}/images/upload/banner/${value.Image}`}
                        class="banner-image"
                      />
                    </Link>
                  }
                </div>
              );
            })
          }
        </Slider>
      </div>
      <div className="center lp-padding10 lp-margintop10">
        <div className="article-title lp-head-font">{title.Detail}</div>
        <div className="article-content lp-body-font">{body.Detail}</div>
        <div className="lp-flex-row center">
          <a
            href={`/shopitem/${memberID}?i=${title.ItemUnitID}`}
            target="_blank"
          >
            <img
              src={`${CMS_URL}/images/upload/button/${button.Image}`}
              className="lp-buy-button"
            />
          </a>
        </div>
      </div>
      <div className="center lp-padding10 lp-margintop10">
        {/* <div className="lp-flex-container">
                    <div className="lp-flex-items" style={{width:'50%'}}>
                        <div className="article-title lp-head-font">Kenapa harus pakai Moorlife Qiana Set?</div>
                        <div className="article-content lp-body-font">
                            Moorlife Qiana Set hadir dengan fitur yang lengkap mulai dari tempat bekal, botol minum, cutleria (sendok dan garpu), serta stylish bag yang modern sehingga mudah untuk dibawa ke mana aja!
                        </div>
                        <img src={FotoProduk} className="lp-product-image"/>
                    </div>
                    <div className="lp-flex-items" style={{width:'50%'}}>
                        <div className="lp-flex-row">
                            <div className="lp-flex-container">
                                <div style={{padding:"10px",width:"50%"}}>
                                    <img src={FiturProduk1} style={{width:"100%"}} />
                                    <div className="lp-body-font">
                                        Memiliki 3-4 sekat yang bisa disesuaikan dengan kebutuhanmu
                                    </div>
                                </div>
                                <div style={{padding:"10px",width:"50%"}}>
                                    <img src={FiturProduk2} style={{width:"100%"}} />
                                    <div className="lp-body-font">
                                        Desain baru dengan tambahan sekat yang mudah dilepas-pasang
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="lp-flex-row">
                            <div className="lp-flex-container">
                                <div style={{padding:"10px",width:"50%"}}>
                                    <img src={FiturProduk3} style={{width:"100%"}} />
                                    <div className="lp-body-font">
                                        Dilengkapi dengan <i>stylish bag</i>
                                    </div>
                                </div>
                                <div style={{padding:"10px",width:"50%"}}>
                                    <img src={FiturProduk4} style={{width:"100%"}} />
                                    <div className="lp-body-font">
                                        Dilengkapi <i>cutleria</i> dan kantong dalam bagian tas untuk wadah <i>cutleria</i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
        {features.map((value, index) => {
          return (
            <img
              src={`${CMS_URL}/images/upload/feature/${value.Image}`}
              style={{ width: "100%" }}
            />
          );
        })}
      </div>
      <div className="center lp-padding10 lp-margintop10">
        <div className="lp-flex-row center">
          <a
            href={`/shopitem/${memberID}?i=${title.ItemUnitID}`}
            target="_blank"
          >
            <img
              src={`${CMS_URL}/images/upload/button/${button.Image}`}
              className="lp-buy-button"
            />
          </a>
        </div>
      </div>
      <div className="lp-flex-container bg-pink lp-padding10 lp-body-font">
        <div className="lp-flex-items">
          <div className="lp-flex-row center">
            <img src={Keunggulan1} className="lp-icon-keunggulan" />
            <span className="keunggulan-text">
              Food <span className="keunggulan-text-bold">Save</span>
            </span>
          </div>
        </div>
        <div className="lp-flex-items">
          <div className="lp-flex-row center">
            <img src={Keunggulan2} className="lp-icon-keunggulan" />
            <span className="keunggulan-text">
              BPA <span className="keunggulan-text-bold">Free</span>
            </span>
          </div>
        </div>
        <div className="lp-flex-items">
          <div className="lp-flex-row center">
            <img src={Keunggulan3} className="lp-icon-keunggulan" />
            <span className="keunggulan-text">
              Non <span className="keunggulan-text-bold">Toxic</span>
            </span>
          </div>
        </div>
        <div className="lp-flex-items">
          <div className="lp-flex-row center">
            <img src={Keunggulan4} className="lp-icon-keunggulan" />
            <span className="keunggulan-text">
              ISO <span className="keunggulan-text-bold">Standart</span>
            </span>
          </div>
        </div>
        <div className="lp-flex-items">
          <div className="lp-flex-row center">
            <img src={Keunggulan5} className="lp-icon-keunggulan-width" />
            <span className="keunggulan-text">
              <span className="keunggulan-text-bold">Moor</span>Lifetime{" "}
              <span className="keunggulan-text-bold">Guarantee</span>
            </span>
          </div>
        </div>
      </div>
      <div className="center lp-padding10 lp-margintop10">
        <div className="article-title lp-head-font">#MoorlifePilihanku</div>
        <div className="article-content lp-body-font">
          Yuk bangga produk Indonesia! Dengan menggunakan Moorlife kamu juga
          mendukung gerakan Go Green karena mengurangi penggunaan plastik sekali
          pakai. Mereka aja udah mulai, kapan giliran kamu?
        </div>
      </div>
      <div className="center lp-kol-row" style={{ padding: "0 20px" }}>
        <Slider {...settingsKol}>
          <div className="lp-kol-container">
            <img src={KOL1} className="lp-image-kol" />
          </div>
          <div className="lp-kol-container">
            <img src={KOL2} className="lp-image-kol" />
          </div>
          <div className="lp-kol-container">
            <img src={KOL3} className="lp-image-kol" />
          </div>
          <div className="lp-kol-container">
            <img src={KOL4} className="lp-image-kol" />
          </div>
        </Slider>
      </div>
      <div className="lp-flex-container bg-darkpink lp-padding10 lp-margintop20">
        <div className="lp-flex-items">
          <div className="lp-flex-row center">
            <span className="lp-specialdiscount-text lp-head-font">
              MAU DAPAT DISKON SPESIAL KHUSUS HARI INI?
            </span>
          </div>
          <div className="lp-flex-row center">
            <a href={`/memberjoin/${memberID}`} target="_blank">
              <img
                src={ButtonMauQiana}
                style={{ width: "130px", height: "60px" }}
              />
            </a>
          </div>
        </div>
      </div>
      <div className="lp-padding10 lp-margintop10">
        <div className="center article-title lp-body-font">
          Cara Bergabung Menjadi Member
        </div>
        <div className="row">
          <div className="col s3 lp-flex-container lp-borderright">
            <img src={RegisterStep1} className="lp-icon-keunggulan" />
            <div className="lp-flex-row">
              <span className="lp-sub-font" style={{ fontWeight: "bold" }}>
                Klik link dibawah ini
              </span>
              <a href={`/memberjoin/${memberID}`} target="_blank">
                <img src={ButtonJoinNow} />
              </a>
            </div>
          </div>
          <div className="col s3 lp-flex-container lp-borderright">
            <img src={RegisterStep2} className="lp-icon-keunggulan" />
            <div className="lp-flex-row">
              <span
                className="lp-sub-font"
                style={{ fontWeight: "bold", width: "100%" }}
              >
                Isi data diri kamu
              </span>
              <span className="lp-sub-font">
                Isi biodata lengkapmu sesuai form yang ada
              </span>
            </div>
          </div>
          <div className="col s3 lp-flex-container lp-borderright">
            <img src={RegisterStep3} className="lp-icon-keunggulan" />
            <div className="lp-flex-row">
              <span
                className="lp-sub-font"
                style={{ fontWeight: "bold", width: "100%" }}
              >
                Belanja produk Moorlife/PIB
              </span>
              <span className="lp-sub-font">
                Pilih produk favoritmu dan lanjutkan ke metode pembayaran
              </span>
            </div>
          </div>
          <div className="col s3 lp-flex-container lp-borderright">
            <img src={RegisterStep4} className="lp-icon-keunggulan" />
            <div className="lp-flex-row">
              <span
                className="lp-sub-font"
                style={{ fontWeight: "bold", width: "100%" }}
              >
                Selamat Anda sudah terdaftar
              </span>
              <span className="lp-sub-font">
                Anda sudah terdaftar menjadi member dan dapatkan banyak
                keuntungan
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="lp-testimonial-container" style={{ display: "none" }}>
        <div className="article-title lp-testimonial-header">
          <div className="lp-head-font">Testimonial</div>
          <div className="lp-body-font">
            &nbsp;&nbsp;Sukses bersama Moorlife
          </div>
        </div>
        <div>
          <img
            src={ButtonTestiPrev}
            className="lp-control-button"
            id="PrevTestimonial"
            onClick={() => slider?.current?.slickPrev()}
          />
          <img
            src={ButtonTestiNext}
            className="lp-control-button"
            id="NextTestimonial"
            onClick={() => slider?.current?.slickNext()}
          />
        </div>
      </div>
      <div
        className="lp-kol-row"
        style={{ padding: "0 20px", display: "none" }}
      >
        <Slider ref={slider} {...settingsTestimoni}>
          <div>
            <div className="lp-testimonial-content-container">
              <div className="lp-image-testimonial">
                <img src={Testimoni1} />
              </div>
              <div className="lp-testimonial-body">
                <div className="lp-body-font" style={{ fontWeight: "bold" }}>
                  Cut Agustiawati
                </div>
                <div className="lp-body-font">EPM CEO Radhia, Aceh</div>
                <div className="lp-sub-font">
                  Berhasil Ajak 10 Orang Ke Luar Negeri <br />
                  Baru bergabung di Moorlife, eh langsung dapet reward <br />
                  jalan-jalan, bahkan ajak 10 orang teman untuk ikutan <br />
                  jalan-jalan bareng. So happy! <br />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="lp-testimonial-content-container">
              <div className="lp-image-testimonial">
                <img src={Testimoni2} />
              </div>
              <div className="lp-testimonial-body">
                <div className="lp-body-font" style={{ fontWeight: "bold" }}>
                  Erni Marlina Dewi
                </div>
                <div className="lp-body-font">
                  EPM CEO Adinda, Kaur Kab.Bengkulu
                </div>
                <div className="lp-sub-font">
                  Capai Level Master dalam 2 bulan
                  <br />
                  Tak disangka, jaringan bisnis Moorlife bisa membantu saya
                  <br />
                  membangun Ruko & punya mobil, apalagi bonusnya mencapai
                  <br />
                  puluhan juta rupiah setiap bulannya.
                  <br />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="lp-testimonial-content-container">
              <div className="lp-image-testimonial">
                <img src={Testimoni3} />
              </div>
              <div className="lp-testimonial-body">
                <div className="lp-body-font" style={{ fontWeight: "bold" }}>
                  Feny Sasmita
                </div>
                <div className="lp-body-font">CEO Adinda, Bengkulu</div>
                <div className="lp-sub-font">
                  Pandemi, Omzet Malah meroket
                  <br />
                  Di tengah pandemi ini, membuat saya jadi makin cuan, selama
                  <br />
                  tidak putus asa, dan kita mulai terjun di dunia online, saya
                  <br />
                  jamin, omzet bakal terus meroket. Saya telah membuktikan!
                  <br />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="lp-testimonial-content-container">
              <div className="lp-image-testimonial">
                <img src={Testimoni4} />
              </div>
              <div className="lp-testimonial-body">
                <div className="lp-body-font" style={{ fontWeight: "bold" }}>
                  Mariana
                </div>
                <div className="lp-body-font">EPL CEO Radhia, Maumere</div>
                <div className="lp-sub-font">
                  Sekali Gabung langsung sukses
                  <br />
                  14 tahun ikut di dunia MLM, tapi suksesnya hanya lewat
                  <br />
                  Moorlife. Bisa selalu kejar reward apapun dari Moorlife. Jadi
                  <br />
                  cinta mati sama Moorlife.
                  <br />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="lp-testimonial-content-container">
              <div className="lp-image-testimonial">
                <img src={Testimoni5} />
              </div>
              <div className="lp-testimonial-body">
                <div className="lp-body-font" style={{ fontWeight: "bold" }}>
                  Riama Simarmata
                </div>
                <div className="lp-body-font">EPM CEO Dewi, Medan</div>
                <div className="lp-sub-font">
                  Raih Omzet Puluhan Juta Tiap Bulan <br />
                  Berkat Moorlife saya bisa memberikan pendidikan yang layak{" "}
                  <br />
                  kepada anak saya, karena omzet bulanan saya mencapai <br />
                  puluhan juta.
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="lp-testimonial-content-container">
              <div className="lp-image-testimonial">
                <img src={Testimoni6} />
              </div>
              <div className="lp-testimonial-body">
                <div className="lp-body-font" style={{ fontWeight: "bold" }}>
                  Yesi Fitri H
                </div>
                <div className="lp-body-font">EPM CEO Adinda, Bengkulu</div>
                <div className="lp-sub-font">
                  Baru bergabung bisa beli mobil dan ke luar negeri
                  <br />
                  Meski baru berjalan 1 tahun, tapi saya sudah bisa membeli
                  <br />
                  mobil sendiri dan mengikuti berbagai trip perjalanan dalam
                  <br />
                  maupun luar negeri.
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
      <div className="lp-footer">
        <div className="lp-footer-left">
          <span className="lp-head-font">INFORMASI LEBIH LANJUT</span>
          <a onClick={() => clickLink("https://wa.me/6285156939377", "cs")}>
            <img src={ButtonClickHere} style={{ width: "100px" }} />
          </a>
          <span className="lp-sub-font">
            © Copyright 2022 Moorlife. All Rights Reserved.
          </span>
        </div>
        <div className="lp-footer-right">
          <span className="lp-sub-font">Voza Premium Office</span>
          <span className="lp-sub-font">
            Jln. HR. Muhammad no.31 (lantai 31)
          </span>
          <span className="lp-sub-font">Surabaya, Jawa Timur, Indonesia</span>
          <span className="lp-sub-font">Telp: 031-29710988</span>
          <br />
          <div className="row">
            <div className="col s3">
              <a target="_blank" href="https://www.facebook.com/moorlife">
                <img src={ButtonFB} className="lp-footer-icon" />
              </a>
            </div>
            <div className="col s3">
              <a
                target="_blank"
                href="https://www.instagram.com/moorlife.official"
              >
                <img src={ButtonIG} className="lp-footer-icon" />
              </a>
            </div>
            <div className="col s3">
              <a
                target="_blank"
                href="https://www.youtube.com/c/Moorlifeofficial"
              >
                <img src={ButtonYt} className="lp-footer-icon" />
              </a>
            </div>
            <div className="col s3">
              <a
                target="_blank"
                href="https://www.tiktok.com/@moorlife.official"
              >
                <img src={ButtonTikTok} className="lp-footer-icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </React.StrictMode>
  );
};

export default Qiana;
